// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"a0319f87","488":"322ccb3a"}[chunkId] + ".chunk.js";
};